// src/views/scanner/index.js
import Scanner from "./Scanner";

export default Scanner;
